import { Component, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { StoreAttributeEditCategoryViewModel, StoreAttributeEditFieldViewModel, StoreAttributeValueType, toAttributeBoolean } from '../../models/store-attribute.model';

@Component({
  selector: 'app-store-attributes-edit-section',
  templateUrl: './store-attributes-edit-section.component.html',
  styleUrls: ['./store-attributes-edit-section.component.scss'],
})
export class StoreAttributesEditSectionComponent {
  @Input() categories$: Observable<StoreAttributeEditCategoryViewModel[]> = of([]);
  @Input() attributeFieldsGroup!: FormGroup;

  readonly booleanType: StoreAttributeValueType = 'Boolean';
  readonly textType: StoreAttributeValueType = 'Text';
  readonly singleSelectType: StoreAttributeValueType = 'SingleSelect';
  readonly multiSelectType: StoreAttributeValueType = 'MultiSelect';

  getControl(clientKey: string): FormControl {
    return this.attributeFieldsGroup.get(clientKey) as FormControl;
  }

  getDisplayValue(field: StoreAttributeEditFieldViewModel): string {
    const value = this.getControl(field.clientKey)?.value;

    if (value === undefined || value === null || value === '') {
      return '—';
    }

    if (field.valueType === 'Boolean') {
      return toAttributeBoolean(value) ? 'Yes' : 'No';
    }

    if (Array.isArray(value)) {
      return value.map((item) => String(item)).join(', ');
    }

    return String(value);
  }

  getValueFlagClass(field: StoreAttributeEditFieldViewModel): Record<string, boolean> {
    if (field.valueType !== 'Boolean') {
      return {};
    }

    const value = this.getControl(field.clientKey)?.value;
    if (value === undefined || value === null || value === '') {
      return {};
    }

    return {
      'attr-flag-yes': toAttributeBoolean(value),
      'attr-flag-no': !toAttributeBoolean(value),
    };
  }
}
